// AUTO-GENERATED by scripts/gen-paperdoll-manifest.js — do not edit.
// Regenerate after adding/removing files under public/paperdolls/.

export const VARIANTS = {
  "body": [
    "Ape",
    "Demon",
    "Lion",
    "Lizard",
    "Retro",
    "Skeleton",
    "Skin_2",
    "Skin_3",
    "Skin_4",
    "Skin_5",
    "Skin_6",
    "Skin_7",
    "Skin_8",
    "Skin_9",
    "Tiger"
  ],
  "top": [
    "Shirt_Buttoned",
    "Shirt_Double",
    "Shirt_Dressing_Black",
    "Shirt_Dressing_White",
    "Shirt_Lucky",
    "Shirt_Stripped_Blue",
    "Shirt_Stripped_Red",
    "Shirt_White",
    "Sweater_Alchemist",
    "Sweater_Christmas_Elf_1",
    "Sweater_Christmas_Elf_2",
    "Sweater_Christmas_Elf_3",
    "Sweater_Christmas_Santa",
    "Sweater_Elegant_Gray",
    "Sweater_Elegant_White",
    "Sweater_Leather_Thickened_Blue",
    "Sweater_Leather_Thickened_Brown",
    "Sweater_Leather_Thickened_Green",
    "Sweater_Leather_Thickened_Navy",
    "Sweater_Leather_Thickened_Red",
    "Sweater_Padded",
    "Sweater_Starry",
    "Sweater_White",
    "Tunic_Lucky",
    "Tunic_Peasant",
    "Tunic_Valentine"
  ],
  "bottom": [
    "Pants_Alchemist",
    "Pants_Armor_Advanced_Iron",
    "Pants_Armor_Basic_Iron",
    "Pants_Armor_Enchanted",
    "Pants_Armor_Standard_Iron",
    "Pants_Christmas_Elf_1",
    "Pants_Christmas_Elf_2",
    "Pants_Christmas_Elf_3",
    "Pants_Christmas_Santa",
    "Pants_Fancy",
    "Pants_Fisherman",
    "Pants_Leather_Thickened_Blue",
    "Pants_Leather_Thickened_Brown",
    "Pants_Leather_Thickened_Green",
    "Pants_Leather_Thickened_Red",
    "Pants_Lucky",
    "Pants_Shorts_Belt",
    "Pants_Shorts_Ripped_Black",
    "Pants_Shorts_Ripped_Blue",
    "Pants_Shorts_Ripped_Red",
    "Pants_Starry",
    "Pants_Tunic_Commoner",
    "Pants_Tunic_Farmer",
    "Pants_Tunic_Lucky",
    "Pants_Tunic_Peasant",
    "Pants_Tunic_Valentine",
    "Skirt_Battle_Blue",
    "Skirt_Executioner",
    "Skirt_Iron_Blue",
    "Skirt_Iron_Green",
    "Skirt_Iron_Red",
    "Skirt_Long",
    "Skirt_Peasant_1",
    "Skirt_Peasant_2",
    "Underwear_Metal",
    "Underwear_White_Clean",
    "Underwear_White_Dirty"
  ],
  "chest": [
    null,
    "Armor_Iron_1",
    "Armor_Iron_2",
    "Armor_Iron_3",
    "Armor_Iron_4",
    "Vest_Fancy",
    "Vest_Leather",
    "Vest_Old"
  ],
  "hair": [
    null,
    "Brown_1",
    "Brown_10",
    "Brown_11",
    "Brown_12",
    "Brown_13",
    "Brown_14",
    "Brown_15",
    "Brown_2",
    "Brown_3",
    "Brown_4",
    "Brown_5",
    "Brown_6",
    "Brown_7",
    "Brown_8",
    "Brown_9"
  ],
  "beard": [
    null,
    "Brown_1",
    "Brown_2",
    "Brown_3",
    "Brown_4",
    "Brown_5"
  ],
  "feet": [
    null,
    "Armor_Enchanted",
    "Armor_Iron",
    "Black",
    "Christmas_Elf_1",
    "Christmas_Elf_2",
    "Christmas_Elf_3",
    "Christmas_Santa",
    "Leather_Simple",
    "Leather_Spurs",
    "Lucky",
    "Starry",
    "Valentine",
    "White"
  ],
  "hands": [
    null,
    "Gauntlet_Light_Iron",
    "Glove_Iron",
    "Glove_Valentine",
    "Glove_White",
    "Wristguard_Enchanted",
    "Wristguard_Iron"
  ],
  "head": [
    null,
    "Armor_Enchanted",
    "Armor_Gatekeeper",
    "Armor_Guard_Blue",
    "Armor_Guard_Green",
    "Armor_Guard_Red",
    "Armor_Iron_1",
    "Armor_Iron_2",
    "Armor_Iron_3",
    "Armor_Iron_Polished_1",
    "Armor_Iron_Polished_2",
    "Armor_Iron_Polished_3",
    "Armor_Iron_Polished_4",
    "Armor_Iron_Polished_5",
    "Armor_Iron_Polished_6",
    "Armor_Iron_Polished_7",
    "Armor_Iron_Polished_8",
    "Armor_Iron_Polished_9",
    "Armor_Leather",
    "Bandana_Blue",
    "Bandana_Pirate",
    "Bandana_Red",
    "Fancy_Crown_Prince",
    "Fancy_Tiara",
    "Hat_Alchemist",
    "Hat_Beret_Brown",
    "Hat_Beret_Green",
    "Hat_Captain_Black",
    "Hat_Captain_Blue",
    "Hat_Captain_Plume",
    "Hat_Cartographer",
    "Hat_Chef_Apprentice",
    "Hat_Chef_Intermediate",
    "Hat_Chef_Master",
    "Hat_Chef_Veteran",
    "Hat_Christmas_Elf_1",
    "Hat_Christmas_Elf_2",
    "Hat_Christmas_Elf_3",
    "Hat_Christmas_Reindeer",
    "Hat_Christmas_Santa",
    "Hat_Christmas_Tree",
    "Hat_Cloth_Blue_Light",
    "Hat_Cloth_Orange",
    "Hat_Farmer_Leather",
    "Hat_Farmer_Straw",
    "Hat_Lucky",
    "Hat_Miner_Off",
    "Hat_Miner_On",
    "Hat_Retro",
    "Hat_Round",
    "Hood_Doctor_M",
    "Hood_Executioner",
    "Hood_Long_Brown_M",
    "Hood_Long_Dark_M",
    "Hood_Monk",
    "Hood_Round",
    "Magical_Dark",
    "Magical_Starry",
    "Magical_Wise",
    "Mask_Ape",
    "Mask_Demon",
    "Mask_Lion_F",
    "Mask_Lion_M",
    "Mask_Lizard",
    "Mask_Pumpkin",
    "Mask_Skull",
    "Mask_Slave",
    "Mask_Tiger"
  ],
  "cape": [
    null,
    "Balloon_Heart",
    "Blue",
    "Christmas",
    "Red",
    "Ripped_Black",
    "Ripped_Red",
    "Tail_Demon",
    "Tail_Lion",
    "Tail_Lizard",
    "Tail_Tiger",
    "Torn_Black",
    "Torn_Brown"
  ],
  "melee": [
    "Knife_Adamantine",
    "Knife_Copper",
    "Knife_Gold",
    "Knife_Iron",
    "Knife_Silver",
    "Knife_Steel",
    "Knife_Wood",
    "Sword_Adamantine",
    "Sword_Angelic",
    "Sword_Basic",
    "Sword_Candy_Cane_1",
    "Sword_Candy_Cane_2",
    "Sword_Candy_Cane_3",
    "Sword_Cobalt",
    "Sword_Copper",
    "Sword_Crimson",
    "Sword_Gold",
    "Sword_Iron_Old",
    "Sword_Iron_Polished",
    "Sword_Platinum",
    "Sword_Silver",
    "Sword_Starting",
    "Sword_Steel",
    "Sword_Training"
  ],
  "offhand": [
    null,
    "Adamantine",
    "Angelic",
    "Cobalt",
    "Copper_1",
    "Copper_2",
    "Crimson",
    "Gold",
    "Iron_1",
    "Iron_2",
    "Platinum",
    "Silver_1",
    "Silver_2",
    "Steel_1",
    "Steel_2",
    "Tin",
    "Wooden"
  ],
  "ranged": [
    "Elite",
    "Iron",
    "Simple"
  ],
  "magic": [
    "Apprentice",
    "Cane",
    "Iron"
  ],
  "artifact": [
    null,
    "Orb_Basic"
  ],
  "quiver": [
    null,
    "Simple"
  ],
  "overall": [
    null,
    "Robe_Necromancer"
  ]
};
